<template>
  <v-container fluid>
    <v-row align="stretch">
      <v-col cols="12">
        <v-row align="center" justify="center">
          <h1>{{ progressTitle }}</h1>
          <v-alert
            color="primary"
            width="90%"
            class="mt-6 problem-title"
            outlined
          >
            {{ currentWord }}
          </v-alert>
        </v-row>

        <v-row align="center" justify="center" class="mt-6">
          <h2 v-text="currentAnswer" class="current-answer"></h2>
        </v-row>
        <v-row align="center" justify="center">
          <v-divider class="answer-boder"></v-divider>
        </v-row>

        <template v-if="this.testState === 'answering'">
          <v-footer fixed class="button-botton-area-footer">
            <v-col cols="12" class="button-botton-area">
              <v-row align="center" justify="center">
                <v-btn
                  bottom
                  class="disable-dbl-tap-zoom"
                  color="primary"
                  height="60px"
                  width="100%"
                  style="max-width=600px"
                  dark
                  @click="executeCheck"
                >
                  答えを見る
                </v-btn>
              </v-row>
            </v-col>
          </v-footer>
        </template>

        <template v-if="this.testState === 'checking'">
          <v-footer fixed class="button-botton-area-footer">
            <v-row class="button-botton-area">
              <v-col cols="4">
                <v-card>
                  <v-btn
                    class="disable-dbl-tap-zoom"
                    color="accent"
                    height="60px"
                    width="100%"
                    @click="wrongButtonTapped"
                  >
                    不正解
                  </v-btn>
                </v-card>
              </v-col>
              <v-col cols="4">
                <v-card>
                  <v-btn
                    class="disable-dbl-tap-zoom"
                    color="primary"
                    height="60px"
                    width="100%"
                    dark
                    @click="correctButtonTapped"
                  >
                    正解
                  </v-btn>
                </v-card>
              </v-col>
              <v-col cols="4">
                <v-card>
                  <v-btn
                    class="disable-dbl-tap-zoom"
                    color="secondary"
                    height="60px"
                    width="100%"
                    dark
                    @click="doneButtonTapped"
                  >
                    完了
                  </v-btn>
                </v-card>
              </v-col>
            </v-row>
          </v-footer>
        </template>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { db, fb } from "../plugins/firebase.js";

export default {
  name: "WordNoteTestMode",
  components: {},
  data: () => ({
    note: null,
    currentIndex: 0,
    words: [],
    editingWords: [],
    testState: "answering", // `answering`, `checking`, `done`
  }),
  async mounted() {
    const noteId = this.$store.getters.currentNoteId;
    this.fetchWords(noteId);

    if (!this.$route.params.note) {
      this.fetchNote(noteId);
    } else {
      this.note = this.$route.params.note;
    }
  },
  methods: {
    async fetchNote(noteId) {
      const that = this;
      const noteSubscription = db
        .collection(`users/${this.uid}/word-notes`)
        .doc(noteId)
        .get()
        .then(function (querySnapshot) {
          that.note = querySnapshot.data();
        });
    },
    async fetchWords(noteId) {
      const that = this;
      const noteSubscription = db
        .collection(`users/${this.uid}/word-notes`)
        .doc(noteId)
        .collection("words")
        .where("done", "==", false)
        .get()
        .then(function (querySnapshot) {
          that.words = (querySnapshot.docs || []).map((doc) => {
            return doc;
          });
        });
    },
    executeCheck() {
      this.testState = "checking";
    },
    correctButtonTapped() {
      this.editingWords.push({
        id: this.words[this.currentIndex].id,
        type: "correct",
      });
      this.testState = "answering";
      this.advanceIndexIfNeeded();
    },
    wrongButtonTapped() {
      this.editingWords.push({
        id: this.words[this.currentIndex].id,
        type: "wrong",
      });
      this.testState = "answering";
      this.advanceIndexIfNeeded();
    },
    doneButtonTapped() {
      this.editingWords.push({
        id: this.words[this.currentIndex].id,
        type: "done",
      });
      this.testState = "answering";
      this.advanceIndexIfNeeded();
    },
    advanceIndexIfNeeded() {
      if (this.words.length - 1 > this.currentIndex) {
        this.currentIndex += 1;
      } else {
        this.testState = "done";
        this.$router.push({
          name: "word-note-test-done",
          params: { editingWords: this.editingWords },
        });
      }
    },
  },
  computed: {
    uid() {
      return this.$store.getters.uid;
    },
    progressTitle() {
      if (this.note != null) {
        return `${this.note.name}(${this.currentIndex + 1}/${
          this.words.length
        })`;
      } else {
        return "";
      }
    },
    currentWord() {
      if (this.words[this.currentIndex] !== void 0) {
        return this.words[this.currentIndex].data().english;
      } else {
        return "";
      }
    },
    currentAnswer() {
      if (this.testState === "answering") {
        return "?";
      } else if (this.testState === "checking") {
        if (this.words[this.currentIndex] !== void 0) {
          return this.words[this.currentIndex].data().japanese;
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
  },
};
</script>

<style scoped>
.container {
  max-width: 600px;
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
}
.problem-title {
  text-align: center;
  font-weight: bold;
  font-size: x-large;
}
.current-answer {
  color: #ff6663;
}
.answer-boder {
  border-color: #ff6663;
  background-color: #ff6663;
  border-top-width: 4px;
  margin-right: 5%;
  margin-left: 5%;
}
.button-botton-area-footer {
  background-color: white !important;
}
.button-botton-area {
  max-width: 600px;
  margin: auto;
}
.disable-dbl-tap-zoom {
  touch-action: manipulation;
}
</style>
